import { Component } from '@angular/core';
import { THashComponent } from '../t-hash/t-hash.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-test-hash',
  templateUrl: './t-test-hash.component.html',
  styleUrls: ['../t-hash/t-hash.component.css','./t-test-hash.component.css']
})
export class TTestHashComponent extends THashComponent {

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, protected httpClient: HttpClient) {
    super(topicService, activatedRoute, httpClient);
    this.type="testHash";
    this.title = this.get("testHash");
   }

   generate(){
     this.count = Math.ceil(Math.random() * 10 + 10);
     this.elementType = Math.random() > 0.5?'number':"string";
     this.count = Math.floor(Math.random() * 20 + 10);
  this.length = this.elementType=='number'?Math.floor(Math.random() * 5 + 5):10;
     this.elements = [];
     this.computeElements();
   }

    /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.elementType = this.configuration.typespecifics.elementType;
    this.fixedElements = true;
    this.elements = this.configuration.typespecifics.elements;
    this.elementS = this.elements.toString();
    this.title = this.configuration.title;
    this.elementType = this.configuration.typespecifics.elementType;
  }

   generateDefinition(): any {
    let definition: any = {};
    definition.typespecifics = {};
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/barchart_white.png";
    definition.description = this.description;
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.key = "searchAndOrder%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics.elements = this.elements;
    definition.key = definition.key.concat("%", this.elements.toString());
    definition.typespecifics.elementType = this.elementType;
    definition.level = 3;
    return definition;
  }

  reset(){
    super.reset();
    this.title = this.get("testHash");
  }

}
